<template>
  <div id="search__flyout" class="search__flyout" :class="hasResultClass">
    <div class="search__wrap">
      <div class="search__field">
        <form :action="urls.submit" @submit="handleSubmit" class="search__form">
          <div class="search__formfield">
            <input
                ref="searchInput"
                v-model="searchTerm"
                :data-brand-group-name="messageKeys.searchSuggestBrand"
                :data-category-group-name="messageKeys.searchSuggestCategory"
                :data-product-group-name="messageKeys.searchSuggestProduct"
                :data-search-suggest-more-text="messageKeys.searchSuggestMoreText"
                :data-suggestions-group-name="messageKeys.searchSuggestSuggestions"
                :placeholder="messageKeys.searchboxPlaceholder"
                autocomplete="off"
                class="search__input"
                maxlength="128"
                name="q"
                type="search"
                @input="handleInput"
            >
            <button class="search__reset" type="reset" @click="resetInput">
              <CloseIcon/>
            </button>
            <button class="search__button" type="submit">
              <SearchIcon/>
            </button>
          </div>
        </form>
        <button type="button" class="search__close" @click="closeFlyout">
          <CloseIcon/>
        </button>
      </div>
      <div class="search__results" v-if="searchTerm.length >= 2">
        <div class="search__categories">
          <div class="search__subheadline">
            {{ messageKeys.searchSuggestCategory }}
          </div>
          <ul v-if="categories.length" class="search__categories-list">
            <SearchCategoryItem
                v-for="(category, index) in categories"
                :key="category.categoryId"
                :highlighted-name="category.entryHighlightedTitle"
                :index="index"
                :name="category.entryName"
                :url="category.entryUrl"
            />
          </ul>
        </div>
        <div class="search__products">
          <div class="search__subheadline">
            {{ messageKeys.searchSuggestProduct }}
          </div>
          <div v-if="products.length" class="search__products-list">
            <SearchProductItem
                v-for="(product, index) in products"
                :key="index"
                :highlighted-name="product.entryHighlightedTitle"
                :image-url="product.imageUrl"
                :index="index"
                :min-price="product.minPrice"
                :name="product.entryName"
                :old-price="product.oldPrice"
                :url="product.entryUrl"
            />
          </div>
        </div>
      </div>
      <div class="search__more more-wrapper" v-if="searchTerm.length >= 2">
        <a :href="moreLink" class="jh-btn-secondary search__more-button">{{ messageKeys.searchSuggestMoreText }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from '../../utils/debounce';

import SearchCategoryItem from './SearchCategoryItem.vue';
import SearchProductItem from './SearchProductItem.vue';
import CloseIcon from "../assets/CloseIcon.vue";
import SearchIcon from "../assets/SearchIcon.vue";

export default {
  props: {
    query: String,
  },
  data() {
    return {
      searchTerm: '',
      categories: [],
      products: [],
      urls: {
        rest: `${window.shopConfig.restUrl}searchSuggest`,
        submit: window.shopConfig.searchSubmitUrl
      },
      messageKeys: {
        searchSuggestMoreText: this.$getTranslation('HEADER.SEARCH.SUGGEST.MORE'),
        searchSuggestBrand: this.$getTranslation('HEADER.SEARCH.SUGGEST.BRAND'),
        searchSuggestSuggestions: this.$getTranslation('HEADER.SEARCH.SUGGEST.SUGGESTIONS'),
        searchSuggestProduct: this.$getTranslation('HEADER.SEARCH.SUGGEST.PRODUCT'),
        searchSuggestCategory: this.$getTranslation('HEADER.SEARCH.SUGGEST.CATEGORY'),
        searchboxPlaceholder: this.$getTranslation('HEADER.SEARCHBOX.PLACEHOLDER')
      }
    }
  },
  components: {
    SearchCategoryItem,
    SearchProductItem,
    CloseIcon,
    SearchIcon
  },
  computed: {
    moreLink() {
      return `${this.urls.submit}?q=${this.searchTerm}`;
    },
    hasResultClass() {
      return {
        'search__flyout--result': (this.products.length || this.categories.length) && this.searchTerm.length >= 2
      };
    }
  },
  methods: {
    closeFlyout() {
      this.$emit('closeFlyout');
    },
    focusInput() {
      this.$refs.searchInput.focus();
    },
    resetInput() {
      this.searchTerm = '';
      this.focusInput();
    },
    handleInput: debounce(function () {
      if (this.searchTerm.length >= 2) {
        this.getResults();
      }
    }, 250),
    async fetchResults() {
      const response = await fetch(`${this.urls.rest}/?q=${this.searchTerm}`);

      return response.json();
    },
    getResults() {
      this.fetchResults().then((data) => {
        this.categories = data.categorySuggestions;
        this.products = data.productSuggestions;
      });
    },
    handleSubmit(e) {
      if (!this.searchTerm.length) {
        e.preventDefault();
      }
    }
  },
  mounted() {
    this.searchTerm = this.query;
    this.focusInput();
    if (this.searchTerm.length >= 2) {
      this.getResults();
      document.getElementById('search__flyout').scrollTo(0, 0);
    }
  }
}
</script>
